import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as RemoveIcon } from "src/images/cross-alt.svg";
import type { WsMemberSelectedContext } from "src/redux/ai-chat/aiChatTypes";

import "./SelectedContextBadge.scss";

interface SelectedContextBadgeProps {
  selectedContext: WsMemberSelectedContext;
  onRemove?: () => void;
}

export default function SelectedContextBadge({
  selectedContext,
  onRemove,
}: SelectedContextBadgeProps) {
  return (
    <div className="selected-context-badge">
      <span>
        <IDHFormattedMessage id="ws_selected" defaultMessage="Selected" />{" "}
        {selectedContext.data.length}{" "}
        <IDHFormattedMessage id="ws_items" defaultMessage="item(s)" />
      </span>
      {onRemove && (
        <button
          type="button"
          className="selected-context-badge__clear"
          onClick={onRemove}
        >
          <RemoveIcon className="ai-chat__icon" />
        </button>
      )}
    </div>
  );
}
